import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper,
  Title,
  Information,
  Closure,
  ClosureInfo,
} from './styled';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { ABREV_MONTHS, getStateConfig } from '@app/src/common/datePicker/state/calendar/constants';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { addDateSelected, deleteDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { SectionDateSelected } from '@app/src/common/datePicker';
import {
  TypePublicationModel,
  FormActions,
  setPrintAllByChannel,
  selectExtracharge,
} from '@app/src/views/StepTwo/channelPublication';
import { setPriceTotalByChannel } from '@app/src/views/StepOne/form/state/priceTotal/actions';

interface Props {
  handleClickNext: Function;
  handleClickBack: Function;
  title: string;
  priceAside: number;
  open: boolean;
  categoryId?: number;
}

export const DatePickerConsume: React.FC<Props> = ({
  handleClickNext,
  handleClickBack,
  categoryId
}) => {

  const dispatch = useDispatch();

  const dateSelected = useSelector(state => state.calendar);
  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const channelId = currentChannel && currentChannel.id;
  const newspaperId = currentChannel && currentChannel.newspaperId;
  let currentDateSelected = dateSelected[getStateConfig[channelId]];
  const isButtonNextDisabled: boolean = currentDateSelected && currentDateSelected.length === 0;
  const categoryTheme = CATEGORIES[CATEGORY[categoryId]];
  const priceTotalData = useSelector(state => state.priceTotal.data);
  const extrachargesByChannel = useSelector(state => state.extracharge.data);
  const currentExtracharges = extrachargesByChannel && extrachargesByChannel[channelId];
  const currentExtrachargesData = currentExtracharges && currentExtracharges.data;
  const extraWords = useSelector(state => state.print.general.extraWords);
  const availableCounter = useSelector(state => state.myPackageAvailable.counter);
  const counterBoth = availableCounter && availableCounter.both;
  const availableByNewspaper = availableCounter && availableCounter[newspaperId];
  const printsByChannel = useSelector(state => state.print.printsByChannel);

  const [priceIgvExtracharge, setPriceIgvExtracharge] = useState(0);
  const [priceExtracharge, setPriceExtracharge] = useState(0);
  const [isDisabledRestDay, setIsDisabledRestDay] = useState(false);
  const [isUpdateExtracharge, setIsUpdateExtracharge] = useState(false);

  useEffect(() => {
    const arrDetails = hydrateSelecteds();
    dispatch(setPrintAllByChannel(String(channelId), arrDetails));
  }, [currentDateSelected]);

  const hydrateSelecteds = () => {
    const arr = currentDateSelected && currentDateSelected.map(item => ({
      dayMonth: item.dayMonth,
      fullDate: item.fullDate,
      month: item.month,
      year: item.year,
      publicationId: currentChannel && currentChannel.id,
      newspaperId: currentChannel && currentChannel.newspaperId,
      packageId: currentChannel && currentChannel.packageId,
      price: currentChannel && currentChannel.price,
      priceIgv: currentChannel && currentChannel.priceIgv,
      datePrint: `${item.year}-${getZeroFormatDate(item.month + 1)}-${getZeroFormatDate(item.dayMonth)}`,
      dateFormat: `${item.fullDate} ${item.year}`
    }))
    return arr;
  };

  const getZeroFormatDate = (date: number) => {
    if (date <= 9) {
      return `0${date}`;
    }
    return date;
  };

  useEffect(() => {
    if (priceTotalData && Object.keys(priceTotalData).length > 0) {
      let currentPrice = 0;
      Object.keys(priceTotalData).map((id) => {
        currentPrice = currentPrice + priceTotalData[id].priceIgv;
      });
    }
  }, [priceTotalData]);

  useEffect(() => {
    if (currentExtrachargesData && currentExtrachargesData.length > 0) {
      let price = 0;
      let priceIgv = 0;
      currentExtrachargesData.map((item) => {
        if (item.checked === true) {
          if (item.alias === 'palabra-extra') {
            price = price + (item.price * extraWords);
            priceIgv = priceIgv + (item.priceIgv * extraWords);
          } else {
            price = price + item.price;
            priceIgv = priceIgv + item.priceIgv;
          }
        }
      });
      setPriceExtracharge(price);
      setPriceIgvExtracharge(priceIgv);
    }
  }, [currentExtrachargesData]);

  useEffect(() => {
    if (channelId) {
      dispatch(setPriceTotalByChannel(currentChannel.id,
        {
          price: ((currentChannel.price) + priceExtracharge) * (currentDateSelected && currentDateSelected.length),
          priceIgv: (currentChannel.priceIgv + priceIgvExtracharge) * (currentDateSelected && currentDateSelected.length)
        }));
    }
  }, [priceIgvExtracharge, currentDateSelected, priceExtracharge, currentChannel]);

  const setDisabledDates = (currentPrints) => {
    const availablesById = availableByNewspaper && availableByNewspaper.print;
    if (currentPrints === availablesById) {
      setIsDisabledRestDay(true);
    } else if (currentPrints > availablesById) {
      setIsDisabledRestDay(true);
    } else {
      setIsDisabledRestDay(false);
    }
  };

  useEffect(() => {
    if (isUpdateExtracharge) {
      setIsUpdateExtracharge(false);
      const extraSelecteds = currentExtrachargesData && currentExtrachargesData.filter(item => item.checked === true);
      for (let i = 0; i < extraSelecteds.length; i++) {
        const selected = extraSelecteds[i];
        let printsAllWithExtra = getPrintsRestNewspaperByExtracharge(selected.extrachargeId, newspaperId) + currentDateSelected.length;
        let currentAvailableExtra = availableByNewspaper.extra && availableByNewspaper.extra[selected.extrachargeId];
        const isInBoth = counterBoth && counterBoth.hasOwnProperty(selected.extrachargeId);
        const group = { 1: [1, 3], 2: [2, 4, 5] };
        const currentGroup = group[newspaperId];
        const groupBoth = { 1: 2, 2: 1 };

        if (isInBoth) {
          printsAllWithExtra = getPrintsRestAllBothNewspaperByExtracharge(selected.extrachargeId) + currentDateSelected.length;
          currentAvailableExtra = counterBoth[selected.extrachargeId];
        }

        currentGroup.map((channel) => {
          const currentExtras = extrachargesByChannel[channel].data;

          if (channel === channelId && currentDateSelected.length === 0) {
            dispatch(selectExtracharge(channel, selected.extrachargeId, false, currentAvailableExtra - printsAllWithExtra));
          } else {
            const beforeItem = currentExtras.filter(x => x.extrachargeId === selected.extrachargeId)[0];

            dispatch(selectExtracharge(channel, selected.extrachargeId, beforeItem.checked, currentAvailableExtra - printsAllWithExtra));
          }
        });

        if (counterBoth && counterBoth[selected.extrachargeId]) {
          const lastNewspaper = groupBoth[newspaperId];
          const alternGroup = group[lastNewspaper];

          alternGroup.map(channel => {
            const currentExtras = extrachargesByChannel[channel].data;
            const beforeItem = currentExtras.filter(x => x.extrachargeId === selected.extrachargeId)[0];
            dispatch(selectExtracharge(channel, selected.extrachargeId, beforeItem.checked, currentAvailableExtra - printsAllWithExtra));
          });
        }
      }
    }
  }, [isUpdateExtracharge, currentDateSelected]);

  useEffect(() => {
    if (printsByChannel[channelId] && printsByChannel[channelId].length !== currentDateSelected) {
      const currentSelectsFromOtherFromChannel = getPrintsMinusCurrentChannel();
      const currentPrints = currentSelectsFromOtherFromChannel + currentDateSelected.length;
      setDisabledDates(currentPrints);
      setIsUpdateExtracharge(true);
    }
  }, [currentDateSelected, printsByChannel]);

  const getPrintsMinusCurrentChannel = () => {
    const group = { 1: [1, 3], 2: [2, 4, 5] };
    const currentGroup = group[newspaperId];
    let count = 0;

    currentGroup.map(channel => {
      if (channel !== channelId) {
        count = count + (printsByChannel[channel] && printsByChannel[channel].length || 0)
      }
    });
    return count;
  };

  const handleAddDay = useCallback(
    (date: DateSelectedType) => {
      const printsSelectRestNewspaper = getPrintsMinusCurrentChannel();
      const totalDateSelected = printsSelectRestNewspaper + currentDateSelected.length + 1;
      const extraSelecteds = currentExtrachargesData && currentExtrachargesData.filter(item => item.checked === true);
      let isBlocked = false;

      if (extraSelecteds && extraSelecteds.length > 0) {
        for (let i = 0; i < extraSelecteds.length; i++) {
          const extra = extraSelecteds[i];
          let printsAllWithExtra = getPrintsRestNewspaperByExtracharge(extra.extrachargeId, newspaperId) + currentDateSelected.length + 1;
          let currentAvailableExtra = availableByNewspaper.extra && availableByNewspaper.extra[extra.extrachargeId];
          const isInBoth = counterBoth && counterBoth.hasOwnProperty(extra.extrachargeId);
          if (isInBoth) {
            printsAllWithExtra = getPrintsRestAllBothNewspaperByExtracharge(extra.extrachargeId) + currentDateSelected.length + 1;
            currentAvailableExtra = counterBoth[extra.extrachargeId];
          }
          if (printsAllWithExtra > currentAvailableExtra) {
            alert('No hay extracargos suficientes');
            isBlocked = true;
            break;
          }
        }
      }
      setAddDaySelect(isBlocked, totalDateSelected, date);
    },
    [dispatch, currentDateSelected]
  );

  const getPrintsRestNewspaperByExtracharge = (extrachargeId, newspaperId) => {
    const group = { 1: [1, 3], 2: [2, 4, 5] };
    const currentGroup = group[newspaperId];
    let count = 0;

    currentGroup.map(channel => {
      const extraSelecteds = extrachargesByChannel[channel].data.filter(item => item.checked === true);
      extraSelecteds.map(selected => {
        if (selected.extrachargeId === extrachargeId) {
          if (channel !== channelId) {
            count = count + (printsByChannel[channel] && printsByChannel[channel].length || 0)
          }
        }
      })
    });
    return count;
  };

  const getPrintsRestAllBothNewspaperByExtracharge = (extrachargeId) => {
    const groupBoth = { 1: 2, 2: 1 };
    const complementNewspaperId = groupBoth[newspaperId];
    const printsRestNewspaperWithExtra = getPrintsRestNewspaperByExtracharge(extrachargeId, newspaperId);
    const printsComplementNewspaperWithExtra = getPrintsRestNewspaperByExtracharge(extrachargeId, complementNewspaperId);
    return printsRestNewspaperWithExtra + printsComplementNewspaperWithExtra;
  };

  const setAddDaySelect = (isBlocked, totalDateSelected, date) => {
    const availablesById = availableByNewspaper && availableByNewspaper.print;
    if (!isBlocked) {
      if (totalDateSelected === availablesById) {
        dispatch(addDateSelected(date, channelId));
        setIsDisabledRestDay(true);
      } else if (totalDateSelected > availablesById) {
        setIsDisabledRestDay(true)
      } else {
        dispatch(addDateSelected(date, channelId));
      }
    }
  };

  const handleDeleteDay = useCallback(
    (date: DateSelectedType) => {
      dispatch(deleteDateSelected(date, channelId));
      setIsDisabledRestDay(false);
    },
    [dispatch, currentDateSelected]
  );

  const handleClickDay = (day: DayType) => {
    const isSameDate = currentDateSelected && currentDateSelected.filter(e => e && day && e.dayMonth === day.dayMonth && e.month === day.month);
    if (!(isSameDate && isSameDate.length)) {
      const fullDate: string = `${day.dayName}. ${day.dayMonth} ${ABREV_MONTHS[day.month]}.`
      const selected = {
        id: day.id,
        dayMonth: day.dayMonth,
        month: day.month,
        year: day.year,
        fullDate,
        stateMonth: day.stateMonth
      }
      handleAddDay(selected);
    }
    const datePicked = dateIsSelected(day);
    if (datePicked) {
      handleDeleteDay(datePicked);
    }
  };

  const dateIsSelected = (day: DayType) => {
    return currentDateSelected && currentDateSelected.filter(e => e && day && e.dayMonth === day.dayMonth && e.month === day.month && e.year === day.year)[0];
  };

  const convertToArray = (text: string) => text.split(',');

  const getDataFromCalendar = () => ({
    id: channelId,
    newspapper: newspaperId,
    packageId: currentChannel && currentChannel.packageId,
    printDate: currentDateSelected
  });

  const propClickNext = () => {
    handleClickNext && handleClickNext(getDataFromCalendar());
  };

  const propClickBack = () => {
    handleClickBack && handleClickBack(getDataFromCalendar());
  };

  return (
    <React.Fragment>
      <Wrapper>
        <Title>¿Cuándo quieres publicar?</Title>
        <SectionDateSelected
          currentDateSelected={currentDateSelected}
          categoryTheme={categoryTheme}
          handleClickDeleteDay={handleDeleteDay}
          handleClickDay={handleClickDay}
          isDisabledRest={isDisabledRestDay}
        />
        <Information>
          <Closure>Cierre de publicación:</Closure>
          {
            currentChannel && currentChannel.description && convertToArray(currentChannel.description).map((date, index) => (
              <ClosureInfo key={index}>- {date}</ClosureInfo>
            ))
          }
        </Information>
      </Wrapper>
      <FormActions
        textButtonBack={'Datos del aviso'}
        handleButtonBack={propClickBack}
        handleButtonNext={propClickNext}
        disabledButtonNext={isButtonNextDisabled} />
    </React.Fragment>
  )
};
